module.exports = __webpack_public_path__ + "img/goods4.1c94e834.png";